

<template>
  <content-loader
    view-box="0 0 410 200"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
  >
    <!-- circle loader with connection line need rotate -->
    <!-- <rect x="300" y="78" rx="3" ry="3" width="61" height="2" /> 
    <circle cx="288" cy="75" r="26" /> 
    <circle cx="320" cy="21" r="19" /> 
    <circle cx="356" cy="86" r="19" /> 
    <circle cx="299" cy="138" r="19" /> 
    <circle cx="229" cy="113" r="19" /> 
    <circle cx="235" cy="36" r="19" /> 
    <rect x="226" y="54" rx="3" ry="3" width="61" height="2" /> 
    <rect x="225" y="97" rx="3" ry="3" width="61" height="2" /> 
    <rect x="274" y="44" rx="3" ry="3" width="61" height="2" /> 
    <rect x="268" y="110" rx="3" ry="3" width="61" height="2" /> -->

    <!-- simple loader -->
     <circle cx="181" cy="56" r="25" /> 
    <circle cx="221" cy="20" r="17" /> 
    <circle cx="236" cy="71" r="17" /> 
    <circle cx="184" cy="107" r="17" /> 
    <circle cx="129" cy="76" r="17" /> 
    <circle cx="143" cy="17" r="17" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "DirectedTreeLoader",
    components: { ContentLoader }
};
  
</script>